import z, { ZodError } from 'zod';

import { bulkPromoSchema } from '../schemas/bulkPromoSchema';
import type { BulkPromoFormInterface } from '../types/index';

export const validateBulkPromoForm = (values: BulkPromoFormInterface) => {
    try {
        bulkPromoSchema.parse(values);
        return {};
    } catch (error) {
        if (error instanceof ZodError) {
            const fieldErrors = z.flattenError(error).fieldErrors as Record<string, string[] | undefined>;

            return Object.keys(fieldErrors).reduce(
                (acc, field) => {
                    acc[field] = fieldErrors[field]?.[0] ?? 'Invalid value';
                    return acc;
                },
                {} as Record<string, string>
            );
        }
    }
    return {};
};
